import { memo } from "react";
import { ParameterToggle, ToggleLevel } from "./ParameterToggle";
import { Sparkle, Waves, Activity, Circle, Sun, Grid3X3, Zap } from "lucide-react";
import { MusicConfig } from "@/lib/lyria-client";

interface ParameterTogglesProps {
  config: MusicConfig;
  onUpdateConfig: (config: Partial<MusicConfig>) => void;
}

const DENSITY_LEVELS: [ToggleLevel, ToggleLevel, ToggleLevel] = [
  { value: "low", numeric: 0.3, icon: Sparkle },
  { value: "med", numeric: 0.65, icon: Waves },
  { value: "high", numeric: 0.9, icon: Activity },
];

const BRIGHTNESS_LEVELS: [ToggleLevel, ToggleLevel, ToggleLevel] = [
  { value: "low", numeric: 0.4, icon: Sparkle },
  { value: "med", numeric: 0.7, icon: Circle },
  { value: "high", numeric: 0.95, icon: Sun },
];

const CHAOS_LEVELS: [ToggleLevel, ToggleLevel, ToggleLevel] = [
  { value: "low", numeric: 0.6, icon: Sparkle },
  { value: "med", numeric: 1.0, icon: Grid3X3 },
  { value: "high", numeric: 1.5, icon: Zap },
];

export const ParameterToggles = memo(function ParameterToggles({
  config,
  onUpdateConfig,
}: ParameterTogglesProps) {
  return (
    <div className="grid grid-cols-3 gap-3">
      <ParameterToggle
        label="Density"
        levels={DENSITY_LEVELS}
        currentValue={config.density ?? 0.65}
        onChange={(v) => onUpdateConfig({ density: v })}
      />
      <ParameterToggle
        label="Brightness"
        levels={BRIGHTNESS_LEVELS}
        currentValue={config.brightness ?? 0.7}
        onChange={(v) => onUpdateConfig({ brightness: v })}
      />
      <ParameterToggle
        label="Chaos"
        levels={CHAOS_LEVELS}
        currentValue={config.temperature ?? 1.0}
        onChange={(v) => onUpdateConfig({ temperature: v })}
      />
    </div>
  );
});
